export default "__VITE_ASSET__BvYJ8E3v__"